import React from 'react';

const Footer = () => {
  return (
    <div className="flex">
      <span className="w-1/2 text-gray-500">Yomar Gutierrez</span>
      <span className="w-1/2 text-right text-gray-500">devchallenges.io</span>
    </div>
  );
};

export default Footer;
